import React, { Component } from 'react';
import moment from 'moment';
import zhCN from 'antd/es/locale/zh_CN';
import './timeInterval.less';

import {  DatePicker, Select, message,ConfigProvider} from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;

class TimeInterval extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        data: null,
        error: '',
        date: null,
    }
    componentWillMount(props) {

    }

    // 监听时间点击事件
    onChange(value, dateString) {
        if (value.length == 0)
            this.props.clearTime();
        else if (value.length == 2) {
            let date = { startTime: value[0].format('X'), endTime: value[1].format('X') };
            this.props.confirmCallback(date);
        }
    }
    // 选择时间
    onOk(value) {
        let date = { startTime: value[0].format('X'), endTime: value[1].format('X') };
        this.props.confirmCallback(date);
    }
    // 获取时分秒范围数组
    range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    disabledDate(current) {
        // Can not select days before today and today
        return current && current >= moment().endOf('day');
    }


    render() {
        const {
            data,
            error,
            date,
        } = this.state;
        const {disabled,timeKey}=this.props;
        return (
            <ConfigProvider locale={zhCN}>
                <div className="time-interval">
                        {/* 时间选择器 */}
                        <RangePicker
                            className="startEndTime"
                            allowClear='true'
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder={['开始时间', '结束时间']}
                            onChange={this.onChange.bind(this)}
                            onOk={this.onOk.bind(this)}
                            size="40px"
                            key={timeKey}
                            disabled={disabled?true:false}
                            disabledDate={this.disabledDate.bind(this)}
                        />

                </div>
            </ConfigProvider>
        )
    }
}
export default TimeInterval;